import { setIdForPricePoint, setPriceForPricePoint } from '../../../../../../store/actions';

export const updatePricePointForDuration = (
	dispatch: any,
	newDuration: string,
	groupedPricePoints: any,
	selectedKilometrage: string
) => {
	// Update price point ID and price when duration changes
	if (groupedPricePoints && selectedKilometrage) {
		const kilometrageObject = groupedPricePoints[newDuration]?.kilometrages.find(
			(kilometrage: { mileage: number; id: number; pricePerMonth: number }) =>
				kilometrage.mileage.toString() === selectedKilometrage
		);

		if (kilometrageObject) {
			dispatch(setIdForPricePoint(kilometrageObject.id));
			dispatch(setPriceForPricePoint(kilometrageObject.pricePerMonth));
		}
	}
};
